<template>

  <!--  onMountedDefault SEM PARENTESES POIS IRÁ ENVIAR PARÂMETRO DINAMICO  -->
  <ProductionOrderFormUniqueBatchEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      @onLastCreated="onLastCreated"
      ref="embeddable"
      v-model="form"
      v-if="!mountAgain"
      :enabled-submit="enabledSubmit"
      :button-download-pdf="{reportId:this.form.batchList[0].pdfReportId,primaryKey: this.form.productionOrderId, name:this.form.productionOrderCodeLabel}"
      disable-product
      disable-quantity-manually
      disable-deadline
      disable-type-origin>

    <template #title-buttons>

      <ProductionOrderChangeCodeLabelDialog
          @onSubmit="onSubmitChangeCode"
          :primary-key="form.productionOrderId" :production-order-code-label="form.productionOrderCodeLabel"/>

      <PrintLabelDialog
          @onSubmit="onSubmitPrint" :label-id="1"
          enable-production-history
          :header-title="'Ordem de Fabricação: ' + form.productionOrderCodeLabel"
          :foreignKey="form.productionOrderId" foreign-key-column="productionOrderId"/>

      <b-link class="btn btn-outline-secondary mr-2"
              href="https://custom.onlaine.com.br/dashboard/custom/polimix/ordens_fabricacao_orientacoes.html"
              target="_blank">
        <b-icon-info-square class="mr-2"/>
        Orientações
      </b-link>

      <t-button @click="openDialogForm('modal-print-label-1')" v-if="command !== 'insert'">
        <b-icon-printer></b-icon-printer>
        Etiqueta
      </t-button>


    </template>

    <template #header>

      <b-row v-if="command==='insert' && !relationAccessSubValidation('sub-production-order-change-code')">


        <t-input v-model="form.productionOrderCodeLabel"
                 label="Cód. Produção" fixed
                 cols="6"
                 highlight/>

        <t-input
            @change="setGroupProductByLot()" v-model="form.batchList[0].lotId"
            :options="lotOptions"
            select
            cols="6"
            label="Lote" required/>

      </b-row>

      <b-row v-else>

        <b-col cols="6">

          <div class="d-flex" style="justify-content: space-between">

            <div>Cód. Produção</div>

            <a @click="editCodeLabel" v-if="relationAccessSubValidation('sub-production-order-change-code')">Alterar
              código?</a>

          </div>

          <t-input not-row v-model="form.productionOrderCodeLabel"
                   label="Cód. Produção" :required="!inputFixedCodeLabel" hide-label :fixed="inputFixedCodeLabel"
                   highlight/>

        </b-col>

        <t-input cols="6" @change="setGroupProductByLot()" v-model="form.batchList[0].lotId" :options="lotOptions"
                 select
                 label="Lote" required/>


      </b-row>

      <b-row>


        <t-input cols="6" v-model="form.batchList[0].producedWeight" required number
                 label="Peso Total (Kg)" @focusout="validatedProducedWeight()"
                 help="Peso Total do Bag ou Caixa de EVA" :small="msgProducedWeight"/>


        <t-input cols="6" v-model="form.issueDate"
                 required
                 :disabled="!relationAccessSubValidation('sub-production-order-change-issue-date')"
                 @change="getLotByIssueDate" date label="Data Produzido"/>

      </b-row>

      <b-row>

        <!-- Remove a opção de escolha da unide de Sacaria individal, pois a mesma não poderá ser produzida -->

        <t-input cols="4" v-model="productFind.unitId" @change="checkProducedWeight()" :fixed="isUpdate()"
                 :options="unitOptions"
                 select
                 help="Embalagem não poderá ser trocada após a inclusão, devido a consistência no fluxo de processos"
                 label="Embalagem" required/>

        <t-input cols="4" v-model="productFind.modelId" :fixed="isUpdate()" :options="modelOptions"
                 select help="Tipo não poderá ser trocada após a inclusão, devido a consistência no fluxo de processos"
                 label="Tipo" required/>


        <t-input cols="4" v-model="productFind.materialId" @change="onChangeMaterial" :fixed="isUpdate()"
                 :options="materialOptions"
                 select
                 help="Material não poderá ser trocada após a inclusão, devido a consistência no fluxo de processos"
                 label="Material" required/>


      </b-row>

      <t-msg v-show="productFind.materialId === materialOffSpec" danger>Utilize off-spec somente para materiais avulsos como: Material de filtro de manga, extrator de aço
        onde não há análise, para os demais casos utilize Convencional e informe na etapa da qualidade qual o(s)
        parâmetro(s) estão fora de especificação como: Umidade, pH, etc. Para mais informações <b><a class="text-danger"
                                                                                                     href="https://custom.onlaine.com.br/dashboard/custom/polimix/ordens_fabricacao_orientacoes.html"
                                                                                                     target="_blank">confira
          o tutorial.</a></b></t-msg>

      <t-input v-model="form.batchList[0].typeNonConformanceId" :options="typeNonConformanceOptions"
               select
               help="Indique se existe alguma não conformidade na ordem de fabricação (entrará no quadro Off-spec)"
               required
               v-if="productFind.materialId === materialOffSpec"
               label="Tipo Não Conformidade (principal)"/>

      <t-input v-model="form.batchList[0].typeRestrictionId" :options="typeRestrictionOptions"
               select help="Indique se existe alguma restrição na ordem de fabricação (entrará no quadro Liberados)"
               v-if="productFind.materialId !== materialOffSpec"
               label="Tipo de Restrição"/>

    </template>

    <template #before-log="{status}">

      <b-card class="mt-2">

        <b-card-title>Informações de Reprocesso</b-card-title>

        <div v-if="command === 'insert' || command === 'update'">

          Deseja indicar que está Ordem está sendo produzida à partir de outra Ordem Reprocessada?
          <t-help
              title="Caso realizar este procedimento a ordem relacionada será vinculada como origem, além de sair do estoque automaticamente, caso ainda esteja no estoque."/>

          <t-input-code-label :status="status" production v-model="form.reprocessedParentProductionOrderId"/>

        </div>

        <div v-else>

          <div v-if="objValid(form.reprocessedDate)">

            <b-badge variant="warning">REPROCESSADO EM {{ form.reprocessedDate | date }}</b-badge>

            <b-card-title class="mt-2">Ordens novas:</b-card-title>

            <b-table :items="form.reprocessedList" :fields="reprocessedFields" bordered hover responsive>
              <!-- Coluna com link -->
              <template #cell(productionOrderCodeLabel)="data">
                <a :href="'/custom/production/order/' + data.item.productionOrderNumber" target="_blank">
                  {{ data.item.productionOrderCodeLabel }}
                </a>
              </template>

              <template #cell(totalProducedWeight)="data">
                {{ data.item.totalProducedWeight | number }} Kg
              </template>

              <!-- Coluna formatada com data -->
              <template #cell(createdDate)="data">
                {{ data.item.logControl.createdDate | datetime }}
              </template>

              <!-- Coluna da lixeira -->
              <template #cell(actions)="data">

                <b-button variant="danger" size="sm" @click="onReprocessed(data.item.productionOrderId,0, false)">
                  <b-icon-trash class="bi bi-trash"></b-icon-trash>
                </b-button>
              </template>


            </b-table>

            <strong>Total de Itens:</strong> {{ totalCount }} <br/>
            <strong>Peso Total de Reprocessamento:</strong> <span class="font-size-lg">{{
              totalWeight | number
            }} Kg</span>

          </div>

          <div
              v-else-if="objValid(form.reprocessedParentProductionOrderId) && form.reprocessedParentProductionOrderId > 0">


            <a class="btn btn-warning"
               :href="'/custom/production/order/' + form.reprocessedParent.productionOrderNumber" target="_blank">ORDEM
              DE ORIGEM {{ form.reprocessedParent.productionOrderCodeLabel }}</a>

            <br/>
            <b-link @click="onReprocessed(form.productionOrderId,0, true)">Deseja remover o vinculo de origem de
              reprocesso?
            </b-link>


          </div>

          <div v-else>

            <b-link @click="reprocessedEnable = !reprocessedEnable">Vincular esta ordem de fabricação com origem em
              outro bag que foi reprocessado?
            </b-link>

            <div v-if="reprocessedEnable">

              <t-msg info class="mt-2">Informe uma ordem finalizada e em estoque, além de não terem sido usadas já como
                origem em reprocessada.
              </t-msg>

              <t-input-code-label :status="status" production v-model="reprocessedParentProductionOrderId"/>

              <t-button outline-primary
                        @click="onReprocessed(form.productionOrderId,reprocessedParentProductionOrderId, true)">Salvar
              </t-button>

            </div>

          </div>

        </div>


      </b-card>


    </template>

  </ProductionOrderFormUniqueBatchEmbeddable>


</template>
<script>
import productionOrderFormEmbeddableMixin from "@/mixins/embeddable/production/productionOrderFormEmbeddableMixin";

import TypeNonConformanceService from "@/services/modules/production/TypeNonConformance.service";
import TypeRestrictionService from "@/services/modules/production/TypeRestriction.service";

import UnitService from "@/services/modules/product/Unit.service";
import ModelService from "@/services/modules/product/Model.service";
import MaterialService from "@/services/modules/product/Material.service";
import ProductService from "@/services/modules/product/Product.service";
import ProductionOrderService from "@/services/modules/production/ProductionOrder.service";
import LotService from "@/services/modules/production/Lot.service";
import ui from "@/assets/scripts/ui";
import PrintLabelDialog from "@/views/modules/general/PrintLabelDialog";
import ProductionOrderChangeCodeLabelDialog
  from "@/views/modules/production/ProductionOrder/dialog/ProductionOrderChangeCodeLabelDialog";
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";


export default {
  name: 'PolimixProductionOrderForm',
  components: {PrintLabelDialog, ProductionOrderChangeCodeLabelDialog},
  mixins: [productionOrderFormEmbeddableMixin],
  data() {
    return {
      ui,
      StatusProductionOrderType,
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      inputFixedCodeLabel: true,
      productFind: { /*Campos utilizados para buscar produto*/
        groupProductId: 0,
        modelId: 0,
        unitId: 0,
        materialId: 0,
        groupProduct: "",
      },
      lotList: [],//Listagem com todos os atributos necessários
      lotOptions: [], //Listagem para select
      modelOptions: [],
      unitOptions: [],
      materialOptions: [],
      typeNonConformanceOptions: [],
      typeRestrictionOptions: [],
      materialOffSpec: 17, //Id do material considerado off-spec na Polimix
      stockOffSpec: 6, //id stockPlaceProductInsideId para off-spec na Polimix
      productModelPO: 67,//id do modelo PÓ
      productModelPeletizado: 72,//id do modelo PÓ
      msgProducedWeight: "",
      validationProducedWeightMin: 0,
      validationProducedWeightMax: 0,
      reprocessedEnable: false,
      reprocessedParentProductionOrderId: 0,
      reprocessedFields: [
        {key: "productionOrderCodeLabel", label: "Ordem"},
        {key: "productNameFull", label: "Produto"},
        {key: "createdDate", label: "Criado em"},
        {key: "totalProducedWeight", label: "Peso Produzido"},
        {key: "actions", label: "Ações"}
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },

    async mountedContinued() {

      //Informações padrões de inclusão, porém poderá haver mudanças depois lendo a última OF inserida
      if (this.isInsert()) {

        this.form.companyId = 2
        this.form.issueDate = ui.currentDate();
        this.form.stockPlaceProductInsideId = 1
        this.form.batchList[0].producedQuantity = 1
        this.setFieldValue("page", 120, ui.currentHour())

      } else {

        /*Para Polimix deverá setar os campos abaixo pelo produto*/
        if (this.form.productId > 0) {
          await this.getResumeProduct(this.form.productId);
        }

      }

      await TypeNonConformanceService.selectList().then((response) => {
        this.typeNonConformanceOptions = response
      }).catch(error => this.responseError(error))

      await TypeRestrictionService.selectList().then((response) => {
        this.typeRestrictionOptions = response
      }).catch(error => this.responseError(error))


      await UnitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))

      await ModelService.selectList().then((response) => {
        this.modelOptions = response
      }).catch(error => this.responseError(error))

      await MaterialService.selectList().then((response) => {
        this.materialOptions = response
      }).catch(error => this.responseError(error))

      await this.getLotByIssueDate()


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async getResumeProduct(productId) {

      await ProductService.getResume('id', productId)
          .then(resume => {

            this.productFind.groupProductId = resume.groupProductId
            this.productFind.modelId = resume.modelId
            this.productFind.unitId = resume.unitId
            this.productFind.modelId = resume.modelId
            this.productFind.materialId = resume.materialId

            this.checkProducedWeight()

          })

    },

    async onReprocessed(productionOrderId, reprocessedParentProductionOrderId, redirect) {

      if (reprocessedParentProductionOrderId === 0) {

        ui.msgConfirm(this, 'EXCLUSÃO DE VINCULO DE REPROCESSO', '<span class="text-danger">Tem certeza que deseja remover o vinculo de origem de reprocesso?', async () => {
          await this.onReprocessedAux(productionOrderId, 0, redirect)
        })

      } else {
        await this.onReprocessedAux(productionOrderId, reprocessedParentProductionOrderId, redirect)
      }

    },

    async onReprocessedAux(productionOrderId, reprocessedParentProductionOrderId, redirect) {

      ProductionOrderService.reprocessed(productionOrderId, reprocessedParentProductionOrderId).then(async () => {

        if (redirect) {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Ordem de Fabricação ' + this.form.productionOrderCodeLabel + ' atualizada com informação de origem reprocesso!'
          })

        } else {

          ui.reload()
          ui.toast(this, "", "Ordem removida com sucesso do vinculo de origem de reprocesso")

        }


      }).catch(error => ui.generalResponseError(this, error))


    },

    async onLastCreated(v) {

      if (this.isInsert()) {

        if (v !== null) {

          //Setar valores conforme último lote lançado que não implequem em valores novos
          if (v.productId !== null && v.productId > 0)
            await this.getResumeProduct(v.productId)


          //Último produto inserido do tipo off-spec, por tanto já deixará setado o local de estoque para off-spec id 6
          if (this.productFind.materialId === this.materialOffSpec) {

            //desabilitado em 15/12/2025
            /*this.productFind.modelId = this.productModelPO*/

            //desabilitado em 11/12/2025
            //this.form.stockPlaceProductInsideId = this.stockOffSpec

          }


          if (v.fieldsCustomized !== null && v.fieldsCustomized.length > 0) {

            //Silo Pó
            const fieldSiloPo = v.fieldsCustomized.find(item => item.fieldId === 121)
            const fieldSiloPeletizado = v.fieldsCustomized.find(item => item.fieldId === 122)

            if (fieldSiloPo !== null && fieldSiloPo !== undefined)
              this.setFieldValue("page", 121, fieldSiloPo.integerValue)

            if (fieldSiloPeletizado !== null && fieldSiloPeletizado !== undefined)
              this.setFieldValue("page", 122, fieldSiloPeletizado.integerValue)

          }

        }

      }


    },

    editCodeLabel() {

      if (this.relationAccessSubValidation('sub-production-order-change-code')) {
        this.inputFixedCodeLabel = !this.inputFixedCodeLabel
      }

    },

    async onSubmitPrint() {

      await this.goPath(this.userAuth.currentPage.path, {
        codSuccess: 100,
        returnMessage: 'Impressão enviada com sucesso!'
      })

    },

    async onSubmitChangeCode() {

      await this.goPath(this.userAuth.currentPage.path, {
        codSuccess: 100,
        returnMessage: 'Código alterado com sucesso!'
      })

    },
    async checkConsistenceLot() {

      if (this.isDelete()) {
        return true
      } else {

        let success = false


        if (this.productFind.groupProductId === 0) {
          ui.msgError(this, "Verifique a seleção do lote se está correta e todas as informações foram preenchidas antes de continuar")
        } else {

          await ProductionOrderService.consistenceLotByIssueDateAndGroupProduct(this.form.batchList[0].lotId, this.form.issueDate, this.productFind.groupProductId).then(() => {

            //IMPLEMENTAR MÉTODO NO BACK-END

            success = true
          }).catch(error => this.responseErrorGeneral(error))
        }


        return success

      }

    },
    async onBeforeSubmit() {

      if (this.command !== 'delete') {

        const checkProduct = await this.findProductByPolimixParams()
        const checkLot = await this.checkConsistenceLot()
        let checkStockPlate = false
        let checkModel = false

        /*PRODUTOS DO TIPO SACARIA, SERÃO ALTERADOS PARA 22 UNIDADES AUTOMATICAMENTE*/
        /*todo converter em um parâmetro no cadastro do produto algo como producedDefaultQuantity, padrão 1, porém poderá ser alterado para algum número > 1, válido para novos registros*/
        if (this.form.productId === 61 || this.form.productId === 65 || this.form.productId === 103 || this.form.productId === 107) {
          this.form.batchList[0].producedQuantity = 20
        }else if(this.form.productId === 886){
          this.form.batchList[0].producedQuantity = 20
        }

        if(this.productFind.materialId === this.materialOffSpec)
            //Material off-spec, por tanto não poderá ter restrição, somente Não Conformidade
          this.form.batchList[0].typeRestrictionId = 0
        else{
          //Material convencional, por tanto não poderá Não Conformidade, somente Restrição
          this.form.batchList[0].typeNonConformanceId = 0
        }


        /*
        REMOVIDO EM 15/12/2025
        //Material off-spec com modelo diferente de Pó
        if (this.productFind.materialId === this.materialOffSpec && this.productFind.modelId !== this.productModelPO) {
          ui.msgError(this,'Você informou um material off-spec, porém está selecionado o tipo PÓ, neste tipo de material somente PÓ é aceito na forma física, corrija para poder continuar.')
        }else{
          checkModel = true
        }*/
        checkModel = true


        /*
        REMOVIDO EM 11/12/2025, ATUALMENTE SOMENTE 1 ESTOQUE DISPONÍVEL, NÃO É NECESSÁRIO CRIAR ESTA SEPARAÇÃO, POIS FÍSICAMENTE SOMENTE EXISTEM 1 ESTOQUE
        //Verifica se o estoque é compativel com o material
        if(this.form.stockPlaceProductInsideId === 6 && this.productFind.materialId !== 17) {
          //a) Material convencional no estoque de off-spec
          ui.msgError(this,'Você informou um material convencional, porém esta selecionado o estoque de off-spec que é incompatível, corrija antes de continuar')
        }else if(this.form.stockPlaceProductInsideId === 1 && this.productFind.materialId === 17){
          //b) Material off-spec no estoque de off-spec
          ui.msgError(this,'Você informou um material off-spec, porém esta selecionado o estoque de convencional que é incompatível, corrija antes de continuar')
        }else{
          checkStockPlate = true
        }*/
        checkStockPlate = true

        //Libera a continuidade sem nenhuma condição especial
        if (checkProduct && checkLot && checkStockPlate && checkModel) {
          this.enabledSubmit = true
        }

      } else {
        this.enabledSubmit = true
      }


    },
    async getLotByIssueDate() {


      await LotService.getLotsByDateProduced(this.form.issueDate).then((response) => {

        //Listagem com todos os dados necessários para montagem
        this.lotList = response
        this.lotOptions = []

        if (this.lotList.length === 0) {
          ui.msgError(this, "Nenhum lote programado para a data atual informe a Qualidade para possibilitar a inclusão de novos bags", () => {
            this.goPath(this.userAuth.currentPage.path)
          })
        }

        //Monstagem das options para escolha do lote
        for (const item of this.lotList) {

          const lot = {
            value: item.lotId,
            text: item.lotCodeLabel,
          }

          this.lotOptions.push(lot)

        }

        if (this.lotList.length === 1) {
          this.setGroupProductByLot(this.lotList[0].lotId)
        }


      }).catch(error => this.responseError(error))

    },

    setGroupProductByLot() {

      const lotId = this.form.batchList[0].lotId

      this.productFind.groupProductId = 0
      this.productFind.groupProduct = ""


      if (lotId > 0) {

        const group = this.lotList.find(a => a.lotId === lotId)

        if (group !== undefined) {
          this.productFind.groupProductId = group.groupProductId
          this.productFind.groupProduct = group.groupProduct
        }

      }

    },

    async findProductByPolimixParams() {

      let success = false
      let params = new URLSearchParams()
      params.set("groupProductId", this.productFind.groupProductId)
      params.set("unitId", this.productFind.unitId)
      params.set("modelId", this.productFind.modelId)
      params.set("materialId", this.productFind.materialId)

      await ProductService.selectList(params).then((options) => {

        if (options !== null) {

          if (options.length === 1) {
            this.form.productId = options[0].value
            success = true
          } else if (options.length === 0) {
            ui.msgError(this, "Produto relacionado ao grupo, unidade de medida e embalagem (un. medida) não foi encontrado e não será possível continuar. Verifique com a Qualidade se algum modelo/produto foram alterados")
          } else {
            ui.msgError(this, "Inconsistência com mais que um produto relacionado ao grupo, unidade de medida e embalagem (un. medida) e não será possível continuar. Verifique com a Qualidade se algum modelo/produto foram alterados")
          }
        }

      }).catch(error => this.responseError(error))

      return success

    },

    async onChangeMaterial(value) {
      if (value === this.materialOffSpec) {

        //Desabilitado em 15/12/2025
        /*this.productFind.modelId = this.productModelPO*/

        //Desabilitado em 11/12/2025
        //this.form.stockPlaceProductInsideId = this.stockOffSpec //Armazenamento de off-spec
      }

    },

    validatedProducedWeight() {

      const producedWeight = this.form.batchList[0].producedWeight

      if (producedWeight > 0 && this.validationProducedWeightMin > 0 && this.validationProducedWeightMax > 0 && (producedWeight < this.validationProducedWeightMin || producedWeight > this.validationProducedWeightMax)) {
        ui.msgError(this, 'Peso total informado incorreto: <br /><b>' + this.msgProducedWeight + '</b><br /><br />Você poderá continuar, porém verifique se tem certeza antes.', null, 'Peso total fora do padrão.')
      }

    },

    checkProducedWeight() {

      this.msgProducedWeight = ""
      this.validationProducedWeightMin = 0
      this.validationProducedWeightMax = 0

      if (this.productFind.modelId === this.productModelPO) {
        //Pó

        this.msgProducedWeight = "Pó"

        if (this.productFind.unitId === 6) {
          //Big Bag
          this.msgProducedWeight = "Peso total para Big Bag " + this.msgProducedWeight + ": 100 à 1300 (Kg)"
          this.validationProducedWeightMin = 100
          this.validationProducedWeightMax = 1300
        } else if (this.productFind.unitId === 10) {
          //Mini Bag
          this.msgProducedWeight = "Peso total para Mini Bag " + this.msgProducedWeight + ": 100 à 400 (Kg)"
          this.validationProducedWeightMin = 100
          this.validationProducedWeightMax = 400
        } else if (this.productFind.unitId === 11) {
          //Caixa de EVA 5Kg
          this.msgProducedWeight = "Peso total para EVA 05Kg " + this.msgProducedWeight + ": 250 (Kg)"
          this.validationProducedWeightMin = 250
          this.validationProducedWeightMax = 250
        } else if (this.productFind.unitId === 9) {
          //Caixa de EVA 10Kg
          this.msgProducedWeight = "Peso total para EVA 10Kg " + this.msgProducedWeight + ": 220 (Kg)"
          this.validationProducedWeightMin = 220
          this.validationProducedWeightMax = 220
        } else if (this.productFind.unitId === 19) {
          //Caixa de EVA 11Kg
          this.msgProducedWeight = "Peso total para EVA 11Kg " + this.msgProducedWeight + ": 275 (Kg)"
          this.validationProducedWeightMin = 275
          this.validationProducedWeightMax = 275
        } else if (this.productFind.unitId === 7) {
          //Sacaria de 25Kg
          this.msgProducedWeight = "Peso total para Sacaria 25Kg " + this.msgProducedWeight + ": 500 (Kg)"
          this.validationProducedWeightMin = 500
          this.validationProducedWeightMax = 500
        } else {
          this.msgProducedWeight = ""
        }

      } else if (this.productFind.modelId === this.productModelPeletizado) {
        //Peletizado

        this.msgProducedWeight = "Peletizado"

        if (this.productFind.unitId === 6) {
          //Big Bag
          this.msgProducedWeight = "Peso total para Big Bag " + this.msgProducedWeight + ": 600 à 1300 (Kg)"
          this.validationProducedWeightMin = 600
          this.validationProducedWeightMax = 1300
        } else if (this.productFind.unitId === 10) {
          //Mini Bag
          this.msgProducedWeight = "Peso total para Mini Bag " + this.msgProducedWeight + ": 100 à 700 (Kg)"
          this.validationProducedWeightMin = 100
          this.validationProducedWeightMax = 700
        } else if (this.productFind.unitId === 11) {
          //Caixa de EVA 5Kg
          this.msgProducedWeight = "Peso total para EVA 05Kg " + this.msgProducedWeight + ": 250 (Kg)"
          this.validationProducedWeightMin = 250
          this.validationProducedWeightMax = 250
        } else if (this.productFind.unitId === 9) {
          //Caixa de EVA 10Kg
          this.msgProducedWeight = "Peso total para EVA 10Kg " + this.msgProducedWeight + ": 220 (Kg)"
          this.validationProducedWeightMin = 220
          this.validationProducedWeightMax = 220
        } else if (this.productFind.unitId === 19) {
          //Caixa de EVA 11Kg
          this.msgProducedWeight = "Peso total para EVA 11Kg " + this.msgProducedWeight + ": 250 (Kg)"
          this.validationProducedWeightMin = 250
          this.validationProducedWeightMax = 250
        } else if (this.productFind.unitId === 7) {
          //Sacaria de 25Kg
          this.msgProducedWeight = "Peso total para Sacaria 25Kg " + this.msgProducedWeight + ": 500 (Kg)"
          this.validationProducedWeightMin = 500
          this.validationProducedWeightMax = 500
        } else {
          this.msgProducedWeight = ""
        }

      }

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

  },
  computed: {
    totalWeight() {
      return this.form.reprocessedList.reduce((sum, o) => sum + (o.totalProducedWeight || 0), 0);
    },
    totalCount() {
      return this.form.reprocessedList.length;
    }
  },
}
</script>
